const modifiers = ['shiftKey', 'altKey', 'ctrlKey', 'metaKey'] as const;
const noModifersPressed = (event: KeyboardEvent) => modifiers.every((key) => !event[key]);

const allowKeyAction = (event: KeyboardEvent, allowedKeys: string | string[]) => {
  const keysToCheck = Array.isArray(allowedKeys) ? allowedKeys : [allowedKeys];

  // ? event.getModifierState('CapsLock');

  if (keysToCheck.includes(event.key) && noModifersPressed(event)) {
    return true;
  }

  return false;
};

export { allowKeyAction, modifiers, noModifersPressed };
